export default __webpack_public_path__ + "0b913ba42dfbe1c9552b57caadc4ab31.png";